import { createSelector } from "reselect";

const getRiskProfileResult = (state: any) => state.getIn(['riskProfileViewReducer', 'riskProfileResult']);

const RiskProfileViewSelector = createSelector(
  [getRiskProfileResult],
  (  riskProfileResult,

  ) => ({
    riskProfileResult,
  })
);
export default RiskProfileViewSelector;